import React from 'react';

/* 0.46.10 - Where the ELEMENT sits on the page row ("Position on the
 * page"). Elements flow into one grid row while their column spans
 * fit, so an element after a title shared the title's row and landed
 * on the right. With a position set, the element starts a row of its
 * own (a zero-height break before it) and its column is pushed left,
 * to the center or right with auto margins. Empty = the normal grid
 * flow, as before.
 *
 * 0.46.12 - Every element has it, not only images. */
export function elementPositionOf(e) {
  const p = e && e.page_position;
  return p === 'left' || p === 'center' || p === 'right' ? p : '';
}

/* 0.46.87 - A button's own Alignment in its column (e.align), which
 * wins over the page position for the button inside its column.
 * 0.46.92 - A title's and a Markdown block's too (their text). */
function buttonAlignOf(e) {
  const a = e && ['button', 'title', 'markdown'].includes(e.type) && e.align;
  return a === 'left' || a === 'center' || a === 'right' ? a : '';
}

export function elementPositionStyle(e) {
  const p = elementPositionOf(e);
  const ba = buttonAlignOf(e);
  if (!p && !ba) return null;
  const style = p ? {
    marginLeft: p === 'left' ? 0 : 'auto',
    marginRight: p === 'right' ? 0 : 'auto',
  } : {};
  // 0.46.12 - An element narrower than its column (a button, a title's
  // text) moves to the same side of the column, so it is the element
  // that is seen at the center or right, not only its column. Images
  // do this through their own alignment (imageAlignOf).
  if (e.type === 'button') {
    const a = ba || p;
    Object.assign(style, { display: 'flex', flexWrap: 'wrap',
      justifyContent: a === 'left' ? 'flex-start' : a === 'right' ? 'flex-end' : 'center' });
  } else if (e.type === 'title' || e.type === 'markdown') {
    // 0.46.85 - A text block's lines too, as a title's.
    style.textAlign = ba || p;
  }
  return style;
}

/* The rendered column of `el`, placed: its own row (a break before it)
 * and the auto margins on its column. `node` is the element's column
 * (or an ElementBoundary around it, which passes the style on). */
export function withElementPosition(el, node) {
  const pos = elementPositionStyle(el);
  if (!pos || !React.isValidElement(node)) return node;
  // 0.46.87 - Only a page position starts a row of its own; a button's
  // alignment alone just places it in its column.
  if (!elementPositionOf(el)) {
    return React.cloneElement(node, { style: { ...(node.props.style || {}), ...pos } });
  }
  return React.createElement(React.Fragment, { key: node.key != null ? node.key : (el && el.id) },
    React.createElement('div', { 'aria-hidden': 'true', style: { flexBasis: '100%', height: 0 } }),
    React.cloneElement(node, { style: { ...(node.props.style || {}), ...pos } }));
}
